export const readStoredUserDetails = () => {
    try {
        return JSON.parse(localStorage.getItem("userDetails") || "{}");
    } catch {
        return {};
    }
}

/** Prefer stored currentRole when it is real; else first roleCode on userDetails */
export const getUserRoleCodeFromStorage = () => {
    const raw = localStorage.getItem("currentRole");
    if (raw != null && raw !== "" && raw !== "null" && raw !== "undefined") {
        return raw;
    }
    const userDetails = readStoredUserDetails();
    const roles = Array.isArray(userDetails.roles) ? userDetails.roles : [];
    return roles.find((r) => r?.roleCode)?.roleCode ?? roles[0]?.roleCode ?? null;
};

export const isValidRole = (SUB_TYPE) => {
    const effectiveRole = getUserRoleCodeFromStorage();
    const userDetails = readStoredUserDetails();
    const availableRoles = Array.isArray(userDetails.availableRoles) ? userDetails.availableRoles : [];
    const availablePermissions = Array.isArray(userDetails.permissions) ? userDetails.permissions : [];

    if (availableRoles.length > 1 && effectiveRole === "ROLE_SUPER_ADMIN") return true;

    if (availableRoles.length === 1 && availableRoles.includes("ROLE_SUPER_ADMIN")) return true;

    return availablePermissions.some((p) => p.permissionCode === SUB_TYPE);
}

export const UpdateObject = (oldObject, updatedValue) => {
    return {
        ...oldObject,
        ...updatedValue,
    }
}

export const ScrollToTop = () => {
    window.scrollTo({
        // top: document.body.scrollHeight,
        top: 0,
        behavior: 'smooth'
    });
}

export const setChainIdLS = (chainId)=>{
    if (chainId != null && chainId !== "") {
        localStorage.setItem("chainIdLS", chainId);
    }
}

export const getChainIdLS = ()=>{
   const chainId = localStorage.getItem("chainIdLS");
   if (!chainId || chainId === "null" || chainId === "undefined") {
     return null;
   }
   return chainId;
}

/** Prefix for test/demo hotels in dropdowns and lists (`testHotel` / `demoHotel` on API objects). */
export const getHotelNameDisplayPrefix = (hotel) => {
    if (hotel?.testHotel) return "[Test] ";
    if (hotel?.demoHotel) return "[Demo] ";
    return "";
};

/**
 * Display label for a hotel (master dropdown, search rows, nav selection).
 * Supports `name`, `hotelName`, and `hotelname` on the object.
 */
export const formatHotelDisplayName = (hotel) => {
    if (hotel == null) return "";
    if (typeof hotel !== "object") return String(hotel);
    const baseName =
        hotel.hotelName ?? hotel.name ?? hotel.hotelname ?? "";
    return `${getHotelNameDisplayPrefix(hotel)}${baseName}`;
};

export const ROLE_AUTO_MODE_VIEWER = "ROLE_AUTO_MODE_VIEWER";

export const isAutoModeViewerRoleCode = (roleCode) =>
    roleCode === ROLE_AUTO_MODE_VIEWER;

export const isAutoModeViewerUser = () =>
    isAutoModeViewerRoleCode(getUserRoleCodeFromStorage());

const ADMIN_ROLE_SID = 1;
const SUPER_ADMIN_ROLE_SID = 2;

export const isAdminOrSuperAdminRole = (role) => {
    const sid = Number(role?.sid ?? role?.id);
    return sid === ADMIN_ROLE_SID || sid === SUPER_ADMIN_ROLE_SID;
}

export const hasAdminAndSuperAdminRoles = (roles) => {
    const roleList = Array.isArray(roles) ? roles : [];
    const hasAdmin = roleList.some((role) => Number(role?.sid ?? role?.id) === ADMIN_ROLE_SID);
    const hasSuperAdmin = roleList.some((role) => Number(role?.sid ?? role?.id) === SUPER_ADMIN_ROLE_SID);
    return hasAdmin && hasSuperAdmin;
}

export const isEditingOwnUserAsSuperAdmin = (locationState, loggedInUserDetails) => {
    const isEditUser = Boolean(locationState?.isEditUser);
    const targetSid = locationState?.sid;
    const loggedInSid = loggedInUserDetails?.sid;
    const roles = Array.isArray(loggedInUserDetails?.roles) ? loggedInUserDetails.roles : [];
    const hasSuperAdminRole = roles.some((r) => {
        const roleId = Number(r?.sid ?? r?.id);
        return roleId === 2 || r?.roleCode === "ROLE_SUPER_ADMIN";
    });

    return (
        isEditUser &&
        targetSid != null &&
        loggedInSid != null &&
        Number(targetSid) === Number(loggedInSid) &&
        hasSuperAdminRole
    );
}

/** `viewType` values for hotel dashboard API filters (hotel/search, etc.). */
export const HOTEL_DASHBOARD_VIEW_TYPE = {
    TOTAL: "",
    HMS: "custom",
    IHCL: "hotelApp",
};

const ACTIVE_HOTEL_FILTER_CLASS = "activeHotelFilter";

/** Returns `activeHotelFilter` when `currentViewType` matches `tabViewType`, else `""`. */
export const activeHotelFilterClass = (currentViewType, tabViewType) =>
    currentViewType === tabViewType ? ACTIVE_HOTEL_FILTER_CLASS : "";

/** `viewType` for test/demo hotels dashboard (`hotel/search` body). */
export const TEST_DEMO_HOTEL_DASHBOARD_VIEW_TYPE = {
    TEST: "test",
    DEMO: "demo",
};

/**
 * Active class for test/demo summary cards. When both filters are true (initial load),
 * both tabs stay highlighted; after a tab click they use `hotelTypeFilter` vs `tabViewType`.
 */
export const activeTestDemoHotelFilterClass = (
    hotelTypeFilter,
    testHotelFilter,
    demoHotelFilter,
    tabViewType,
) =>
    testHotelFilter && demoHotelFilter
        ? ACTIVE_HOTEL_FILTER_CLASS
        : activeHotelFilterClass(hotelTypeFilter, tabViewType);